import { classInstance } from '@/shared/helpers/helpers';
import { FormInputWithReset } from '@/shared/form/form-element/form-input/form-input-reset';

export class ModalCities {
	private readonly element: HTMLElement | null;
	private input: HTMLInputElement | null;
	private inputInstance: FormInputWithReset | null;

	constructor(element: HTMLElement | null) {
		this.element = element;
		this.init();
	}

	public init = (): void => {
		if (!this.element) return;

		this.input = document.querySelector('.modal-cities__search .form-input');
		this.inputInstance = new FormInputWithReset(this.input);

		classInstance.set(this.element, { modalCities: this });
	};

	public destroy = (): void => {
		if (!this.element) return;

		this.input = null;
		this.inputInstance = null;

		classInstance.del(this.element, 'modalCities');
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
